import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@pflegix/authentication';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);

  const { accessToken } = authService;

  let newReq = req.clone();

  const hasRequestToken = req.headers.has('Authorization');

  if (accessToken && !hasRequestToken) {
    newReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
    });
  }

  return next(newReq);
};
